import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 0px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 18px 12px 18px;
  h3 {
    color: ${props => props.theme.main.color};
    font-size: 26px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0;
  }
`;

export const Body = styled.div`
  padding: 0 18px 24px 18px;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerImage = styled.div`
  display: flex;
  margin-top: 25px;
  justify-content: center;
`;

type LogoProps = {
  width?: string;
};

export const Logo = styled.img<LogoProps>`
  width: ${props => props.width || '200px'};
`;

export const TableHeaderColor = styled.div`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: ${props => props.theme.main.color};
  height: 16px;
  gap: 12px;
`;

type TableHeaderSegmentProps = {
  isItem?: boolean;
  lastLine?: boolean;
};

export const TableHeaderSegment = styled.div<TableHeaderSegmentProps>`
  display: flex;
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;

  ${({ isItem }) =>
    isItem &&
    css`
      padding-top: 6px;
      padding-bottom: 6px;
    `}

  ${({ lastLine }) =>
    lastLine &&
    css`
      border-bottom: 1px solid #dddddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    `}
`;

export const TableItemContainer = styled.div`
  width: 30%;
`;

type TableResidentialContainerProps = {
  flex?: boolean;
};

export const TableResidentialContainer = styled.div<TableResidentialContainerProps>`
  width: 50%;
  margin-right: 10px;
  display: ${props => (props.flex ? 'flex' : 'inline')};

  .plans {
    color: ${props => props.theme.main.color};
    font-weight: 700;
    width: 33%;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    text-transform: uppercase;
  }
`;

export const TableBusinessContainer = styled.div`
  width: 20%;
  margin-left: 10px;
  margin-right: 10px;
`;

export const SegmentTitle = styled.div`
  color: #854ee0;
  border-bottom: 4px solid #c8acfd;
  display: flex;
  justify-content: center;
  padding: 12px;
  text-transform: uppercase;
  font-weight: 700;
`;

type TableHeaderProps = {
  align: 'center' | 'left';
  width?: string;
  isHead?: boolean;
};

export const TableItem = styled.div<TableHeaderProps>`
  width: ${props => props.width || '100%'};
  text-align: ${props => props.align};
  padding-top: ${props => (props.isHead ? '10px' : '8px')};
  padding-bottom: ${props => (props.isHead ? '10px' : '8px')};

  ${({ isHead }) =>
    isHead &&
    css`
      color: ${props => props.theme.main.color};
      font-weight: 700;
      text-transform: uppercase;
    `}

  ${({ align }) =>
    align === 'left' &&
    css`
      padding-left: 14px;
    `}
`;

export const AssistanceDetailsText = styled.div`
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
`;

export const AssistanceDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #854ee0;
  border-radius: 4px;
  padding: 8px;
  gap: 4px;
  margin-top: 10px;
`;

export const AssistanceDetailsTitle = styled.div`
  color: ${props => props.theme.main.color};
  font-weight: 700;
`;

export const AssistanceDetailsBody = styled.div`
  font-size: 12px
  margin-top: 4px;
`;
